import { createPopoverPlugin } from './src'
import { createRangeToMeasureOverflowWidth } from '../../utils'
import { isFunction } from 'lodash'
const mouseenterRule = (column, headerFlag, vm) => {
  let allow = true
  if (headerFlag) {
    if (column.headerCellRender && !column.showOverflowTooltipOnHeader) {
      allow = false
    }
    if (column.showOverflowTooltipOnHeader === false) {
      allow = false
    }
    if (!vm.$props.showOverflowTooltipOnHeader) {
      allow = false
    }
  } else {
    if (column.showOverflowTooltip === false) {
      allow = false
    }
    // if (column.rowCellRender && !column.showOverflowTooltip) {
    //   allow = false
    // }
    if (!(vm.$props.showOverflowTooltip || vm.$props.noWrap)) {
      allow = false
    }
  }
  return allow || column._isForce
}

export function createTable2PopoverPlugin(vm) {
  // 实例化气泡插件 并挂载在组件上
  const createPopoverPluginInstance = () => {
    if (!vm.popoverPluginInstance) {
      vm.popoverPluginInstance = createPopoverPlugin()
      vm.popoverPluginInstance.getPopperModalInstance({
        wrapClass: 'kye-table2-plugin-popper'
      })
    }
  }
  // 移入单元格事件，显示气泡的逻辑
  const handleMouseEnter = (obj, isHeader = false) => {
    const openDelay = obj.column.popoverOpenDelay || vm.$props.popoverOpenDelay || 1000
    const effect = vm.$props.popoverEffect || 'light'
    const { showCellPopover = false } = obj.column
    const execulteHanlder = () => {
      const { column, event, value, _isForce } = obj
      const flag = mouseenterRule(column, isHeader, vm)
      if (!flag) {
        return
      }
      let content = isHeader ? column.popoverHeadCellContent || column.label : column.popoverContent || value
      if (isFunction(content)) {
        content = content(vm.$createElement, obj)
      }
      const isOverflow = createRangeToMeasureOverflowWidth(event.target) || _isForce || showCellPopover
      // 实际内容未超过列宽或者无气泡内容则阻止
      if (!isOverflow || (!content && content !== 0)) {
        vm.popoverPluginInstance.asyncHiddenPopover()
        return
      }
      const { popperWidth = 'auto', popperClass, visibleArrow = true } = column
      const poppverMergeOptions = {
        width: popperWidth,
        popperClass,
        visibleArrow,
        content,
        openDelay,
        effect
      }
      const reference = event.target
      // 气泡延迟显示，目标元素可能会不在文档中
      document.body.contains(reference) && vm.popoverPluginInstance.showPoppver(reference, poppverMergeOptions)
    }
    clearTimeout(vm._popoverMouseenterTimer)
    vm.popoverPluginInstance.removePopperHandleEvent()
    vm._popoverMouseenterTimer = setTimeout(() => {
      execulteHanlder()
    }, 500)
  }

  // 移除气泡
  const removePopper = () => {
    if (vm.popoverPluginInstance) {
      vm.popoverPluginInstance.hiddenPopover()
      vm.popoverPluginInstance.removePopperHandleEvent()
    }
  }
  // 滚动事件
  const handleScrollEvent = () => {
    vm.$nextTick(() => {
      if (vm.popoverPluginInstance && vm.popoverPluginInstance.getPopperModalInstance().value) {
        removePopper()
      }
    })
  }
  const handleMouseLeave = () => {
    clearTimeout(vm._popoverMouseenterTimer)
  }
  const rowCellRenderEvent = {
    enter: obj => {
      const { column } = obj
      const { rowCellRender, showOverflowTooltip } = column || {}
      const slotCell = vm.$scopedSlots && vm.$scopedSlots.cell
      if ((rowCellRender || slotCell) && !showOverflowTooltip) {
        return
      }
      handleMouseEnter(obj)
    },
    leave: obj => {
      handleMouseLeave()
    }
  }
  const table2EmitEventOffOnHandle = type => {
    const eventHandlers = {
      'header-label-mouse-enter': obj => handleMouseEnter(obj, true),
      'header-label-mouse-leave': handleMouseLeave,
      'cell-mouse-enter': rowCellRenderEvent.enter,
      'cell-mouse-leave': rowCellRenderEvent.leave,
      'cell-copy-mouse-enter': rowCellRenderEvent.enter,
      'cell-copy-mouse-leave': rowCellRenderEvent.leave,
      scroll: handleScrollEvent
    }
    Object.entries(eventHandlers).forEach(([eventName, handler]) => {
      type === 'off' ? vm.$off(eventName, handler) : vm.$on(eventName, handler)
    })
  }

  // 生命周期中监听相关事件
  const lifeCycleHooks = () => {
    vm.$on('hook:mounted', () => {
      createPopoverPluginInstance()
      table2EmitEventOffOnHandle('on')
    })
    // 销毁相关事件
    vm.$on('hook:beforeDestroy', () => {
      table2EmitEventOffOnHandle('off')
      removePopper()
      vm.popoverPluginInstance.destroyPopver()
      vm.popoverPluginInstance = null
    })
    vm.$on('hook:activated', () => {
      createPopoverPluginInstance()
    })
    vm.$on('hook:deactivated', () => {
      removePopper()
    })
  }
  lifeCycleHooks()
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/plugins/popover/index.js